import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Typography, Box, IconButton
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const data = [
  {
	  date: '2025-06-17 9:05 PM',
    scenario: 'Scenario 1: Empathetic Response',
    grade: 'A',
    empathy: 95,
    compassion: 90,
    compliance: 95,
    responsiveness: 93
  },
  {
	  date: '2025-06-16 8:10 AM',
    scenario: 'Scenario 1: Empathetic Response',
    grade: 'B',
    empathy: 76,
    compassion: 81,
    compliance: 84,
    responsiveness: 82
  },
  {
	  date: '2025-06-15 8:42 PM',
    scenario: 'Scenario 1: Empathetic Response',
    grade: 'D-',
    empathy: 60,
    compassion: 72,
    compliance: 54,
    responsiveness: 71
  }
  ,{
	  date: '2025-06-15 8:41 PM',
    scenario: 'Scenario 3: Sundowning',
    grade: 'B-',
    empathy: 81,
    compassion: 72,
    compliance: 84,
    responsiveness: 78
  }
  ,{
	  date: '2025-05-24 7:25 PM',
    scenario: 'Scenario 3: Sundowning',
    grade: 'C-',
    empathy: 71,
    compassion: 68,
    compliance: 74,
    responsiveness: 69
  }
  ,{
	  date: '2025-05-24 7:25 PM',
    scenario: 'Scenario 4: Waking Up',
    grade: 'A-',
    empathy: 91,
    compassion: 82,
    compliance: 94,
    responsiveness: 88
  }
];

export default function History({ setView }) {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Performance Overview
      </Typography>

      <TableContainer component={Paper} sx={{ mb: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Scenario</TableCell>
              <TableCell>Grade</TableCell>
              <TableCell>Empathy</TableCell>
              <TableCell>Compassion</TableCell>
              <TableCell>Compliance</TableCell>
              <TableCell>Responsiveness</TableCell>
              <TableCell align="center">Coaching</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.scenario}</TableCell>
                <TableCell>{row.grade}</TableCell>
                <TableCell>{row.empathy}</TableCell>
                <TableCell>{row.compassion}</TableCell>
                <TableCell>{row.compliance}</TableCell>
                <TableCell>{row.responsiveness}</TableCell>
                <TableCell align="center">
                  <IconButton
                    color="primary"
                    onClick={() => setView('coaching')}
                    aria-label="Go to coaching"
                  >
                    <SchoolIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" gutterBottom>
        Metric Trends
      </Typography>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="empathy" stroke="#8884d8" />
          <Line type="monotone" dataKey="compassion" stroke="#82ca9d" />
          <Line type="monotone" dataKey="compliance" stroke="#ffc658" />
          <Line type="monotone" dataKey="responsiveness" stroke="#ff7300" />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
}

